var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-container full-height" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            visible: _vm.dialogMemberFormVisible,
            title: _vm.roleSettingObj.id
              ? "編輯" +
                _vm.roleSettingObj.account +
                _vm.roleSettingObj.name +
                "帳號"
              : "新增帳號",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogMemberFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("el-alert", {
                    attrs: {
                      closable: false,
                      title:
                        "密碼為使用不可逆的加密演算法，所以密碼無法查詢。只能設定新密碼。",
                      type: "warning",
                      effect: "dark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "memberForm",
                  attrs: {
                    rules: _vm.rules,
                    size: "mini",
                    model: _vm.roleSettingObj,
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "旅行社代碼" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "mini",
                            filterable: "",
                            clearable: "",
                            placeholder: "請選擇",
                          },
                          model: {
                            value: _vm.roleSettingObj.agencyCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.roleSettingObj, "agencyCode", $$v)
                            },
                            expression: "roleSettingObj.agencyCode",
                          },
                        },
                        _vm._l(_vm.agencyList, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { label: item.val, value: item.key },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "帳號", prop: "account" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.roleSettingObj.account,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "account", $$v)
                          },
                          expression: "roleSettingObj.account",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名", prop: "name" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.roleSettingObj.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "name", $$v)
                          },
                          expression: "roleSettingObj.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Mail", prop: "mail" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.roleSettingObj.mail,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "mail", $$v)
                          },
                          expression: "roleSettingObj.mail",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "電話", prop: "mobile" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.roleSettingObj.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "mobile", $$v)
                          },
                          expression: "roleSettingObj.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "生日" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: "請選擇領隊生日",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.roleSettingObj.birthday,
                          callback: function ($$v) {
                            _vm.$set(_vm.roleSettingObj, "birthday", $$v)
                          },
                          expression: "roleSettingObj.birthday",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "狀態" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.roleSettingObj.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.roleSettingObj, "status", $$v)
                            },
                            expression: "roleSettingObj.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("停用"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("啟用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "密碼", prop: "pwd" } },
                    [
                      _vm.roleSettingObj.id
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: {
                                type: _vm.showPwdInupt ? "primary" : "success",
                                size: "mini",
                              },
                              on: { click: _vm.showPwdInuptHandler },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.showPwdInupt ? "取消" : "更改密碼")
                              ),
                            ]
                          )
                        : _vm._e(),
                      !_vm.roleSettingObj.id || _vm.showPwdInupt
                        ? _c("el-input", {
                            attrs: { "show-password": "" },
                            model: {
                              value: _vm.roleSettingObj.pwd,
                              callback: function ($$v) {
                                _vm.$set(_vm.roleSettingObj, "pwd", $$v)
                              },
                              expression: "roleSettingObj.pwd",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "i",
                        {
                          staticStyle: {
                            color: "#ccc",
                            "font-size": "12px",
                            margin: "5px",
                          },
                        },
                        [
                          _vm._v(
                            "密碼原則：密碼必須包含英文，數字及長度介於6-16之間。"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div"),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveData("memberForm")
                    },
                  },
                },
                [_vm._v("確定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogMemberFormVisible = !_vm.dialogMemberFormVisible
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.rolesList.length > 0
        ? _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.dialogFormVisible,
                title:
                  _vm.roleSettingObj.account +
                  _vm.roleSettingObj.name +
                  "-" +
                  "角色設定",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogFormVisible = $event
                },
              },
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.rolesList,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "選取" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { label: scope.row.roleCode },
                                  model: {
                                    value: _vm.rolesSelected,
                                    callback: function ($$v) {
                                      _vm.rolesSelected = $$v
                                    },
                                    expression: "rolesSelected",
                                  },
                                },
                                [_vm._v(" 選取 ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2759007023
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "角色代碼" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" " + _vm._s(scope.row.roleCode) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      243896740
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "角色名稱" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" " + _vm._s(scope.row.roleName) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1840091566
                    ),
                  }),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveRoles },
                    },
                    [_vm._v("確定")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogFormVisible = !_vm.dialogFormVisible
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "full-height",
          staticStyle: { padding: "20px", "padding-bottom": "0" },
        },
        [
          _c(
            "div",
            { staticStyle: { "padding-bottom": "0" } },
            [
              _c(
                "el-alert",
                {
                  staticStyle: { border: "2px solid #ccc", margin: "5px" },
                  attrs: { closable: false, type: "success", effect: "dark" },
                },
                [
                  _c("template", { slot: "title" }, [
                    _c("div", { staticClass: "iconSize" }, [
                      _vm._v("需要注意的事项:"),
                    ]),
                    _c("div", { staticClass: "iconSize" }, [
                      _vm._v(
                        " 1、一般查詢：完整名稱查詢，需輸入完整帳號或姓名才會查詢得到結果。英文會區分大小寫 "
                      ),
                    ]),
                    _c("div", { staticClass: "iconSize" }, [
                      _vm._v(
                        " 2、關鍵字查詢：可使用關鍵字查詢，例：搜尋姓氏為王的名稱，輸入：王%。搜尋名字為小明的名稱，輸入：%小明。英文不用區分大小寫 "
                      ),
                    ]),
                  ]),
                ],
                2
              ),
              _c(
                "el-form",
                {
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleFilter($event)
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "搜尋" } },
                    [
                      _c("el-input", {
                        attrs: { size: "mini", placeholder: "輸入查詢" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleFilter($event)
                          },
                        },
                        model: {
                          value: _vm.listQuery.qry,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "qry", $$v)
                          },
                          expression: "listQuery.qry",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "狀態" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "請選擇狀態", clearable: "" },
                          model: {
                            value: _vm.listQuery.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.listQuery, "status", $$v)
                            },
                            expression: "listQuery.status",
                          },
                        },
                        _vm._l(
                          [
                            { key: 0, val: "停用" },
                            { key: 1, val: "啟用" },
                            { key: 2, val: "黑名單" },
                          ],
                          function (item) {
                            return _c("el-option", {
                              key: item.key,
                              attrs: { label: item.val, value: item.key },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            size: "mini",
                            type: "primary",
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v(" 搜尋 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            size: "mini",
                            icon: "el-icon-plus",
                          },
                          on: { click: _vm.addData },
                        },
                        [_vm._v("建立")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-button", {
                        attrs: {
                          loading: _vm.listLoading,
                          type: "success",
                          icon: "el-icon-refresh-left",
                          circle: "",
                        },
                        on: { click: _vm.refresh },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticStyle: {
                            border: "1px solid #ccc",
                            "user-select": "auto",
                            padding: "10px",
                          },
                          on: { change: _vm.handleFilter },
                          model: {
                            value: _vm.listQuery.listType,
                            callback: function ($$v) {
                              _vm.$set(_vm.listQuery, "listType", $$v)
                            },
                            expression: "listQuery.listType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("所有帳號"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("TC網帳號"),
                          ]),
                          _c("el-radio", { attrs: { label: 3 } }, [
                            _vm._v("App旅客"),
                          ]),
                          _c("el-radio", { attrs: { label: 4 } }, [
                            _vm._v("App領隊"),
                          ]),
                          _c("el-radio", { attrs: { label: 5 } }, [
                            _vm._v("旅行社帳號"),
                          ]),
                          _c("el-radio", { attrs: { label: 6 } }, [
                            _vm._v("ITA行政"),
                          ]),
                          _c("el-radio", { attrs: { label: 7 } }, [
                            _vm._v("ITA管理員"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { position: "relative", height: "80%" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  key: _vm.tableKey,
                  attrs: {
                    size: "mini",
                    data: _vm.list,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "100%",
                  },
                  on: { "sort-change": _vm.sortChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "ID",
                      prop: "id",
                      sortable: "custom",
                      align: "center",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.id))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "帳號",
                      prop: "account",
                      sortable: "custom",
                      align: "left",
                      width: "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.account))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "姓名",
                      prop: "name",
                      sortable: "custom",
                      align: "left",
                      width: "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_c("span", [_vm._v(_vm._s(row.name))])]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "狀態", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    scope.row.status == 0
                                      ? "danger"
                                      : scope.row.status == 2
                                      ? "warning"
                                      : "success",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.status == 0
                                      ? "停用"
                                      : scope.row.status == 2
                                      ? "黑名單"
                                      : "啟用"
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "操作", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  size: "mini",
                                  type: "warning",
                                  icon: "el-icon-edit",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.editData(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 編輯資料 ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "操作", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "filter-item",
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-key",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.showSelfRoles(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 角色設定 ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm.checkPermission(["ITA-DEV"])
                    ? _c("el-table-column", {
                        attrs: { align: "center", label: "刪除", width: "200" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "filter-item",
                                      attrs: {
                                        size: "mini",
                                        type: "danger",
                                        icon: "el-icon-key",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteMember(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 刪除 ")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3523955088
                        ),
                      })
                    : _vm._e(),
                  _vm.checkPermission(["ITA-DEV"])
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "查詢密碼",
                          width: "200",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "filter-item",
                                      attrs: {
                                        size: "mini",
                                        type: "info",
                                        icon: "el-icon-view",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getMemberPwd(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 查詢密碼 ")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          585910272
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            staticStyle: { "padding-top": "0" },
            attrs: {
              total: _vm.total,
              page: _vm.listQuery.page,
              limit: _vm.listQuery.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.listQuery, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.listQuery, "limit", $event)
              },
              pagination: _vm.getList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }